import StudentActivitiesCard from './component'

export default StudentActivitiesCard
